var prefix = require('./prefix')

module.exports = prefix ? 'webkitAnimation' : 'animation'



//////////////////
// WEBPACK FOOTER
// ./~/create-keyframe-animation/lib/animation-property.js
// module id = 1754
// module chunks = 0